import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function aanvraagReducer(state = initialState.aanvraag, action) {
	switch (action.type) {
		case types.AANVRAAG_LOADED: {
			return Object.assign({}, state,
				{
					id: action.body.item ? action.body.item.dossierId : null,
					item: action.body.item,
					errors: action.body.errors
				});
		}

		case types.AANVRAAG_SAVED: {
			return Object.assign({}, state,
				{
					id: action.body.item.dossierId,
					item: action.body.item,
					errors: action.body.errors
				});
		}

		case types.AANVRAAG_CLEARED: {
			return Object.assign({}, initialState.aanvraag);
		}

		default:
			return state;
	}
}
